import { css, Theme } from '@emotion/react'

export const link = (theme: Theme) => css`
  color: ${theme.colors.blueHover};
`
